import { adminClientMessage, AdminResErrorType } from '../../../config/adminRequest';
import { Button, Form, Modal, Spin, Tabs } from 'antd';
import React, { RefObject, useEffect, useState } from 'react';
import { FormInstance } from 'antd/lib/form';
import CoreDrawer from '../../core/components/CoreDrawer';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { useOperatorLogger } from '../../core/hooks/useOperatorLogger';
import * as _ from 'lodash';
import CollectTokenSettingFrom from '../../domain/components/setttings/CollectTokenSettingForm';
import CollectSettingProvider, {
  CollectDestPreviewState,
  CollectSetting,
  NumberComponentType,
  StringComponentType,
} from '../../domain/usdt-providers/collectSettingProvider';


export enum SystemSettingActionType {
  AddAgent,
  AddNormal,
  Extend,
  Edit,
}

const fromEditErrorModel = (
  err: AdminResErrorType,
  state: { type: string },
) => {
  Modal.error({
    title: state.type,
    content: (
      <div>
        <ul>
          <li>原因: {adminClientMessage.get(err.clientCode) ?? err.message}</li>
          {err.clientCode === 'feeRate.check.error' ? (
            <>
              <li>欄位: {err.data.colName}</li>
              <li>最小值: {err.data.min}</li>
              <li>最大值: {err.data.max}</li>
            </>
          ) : (
            <></>
          )}
        </ul>
      </div>
    ),
    okText: '確認',
  });
};

enum ActionType {
  Closed,
}

const formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

const CollectSettingForm = (props: {
  type: SystemSettingActionType;
  visible: boolean;
  closeForm: () => void;
  systemId: string;
}) => {
  let keyNumber = 2;

  const [actionState] = useState(new Subject<ActionType>());
  useEffect(() => {
    actionState.pipe(filter((x) => x === ActionType.Closed)).subscribe((x) => {
      props.closeForm();
    });
    // eslint-disable-next-line
  }, [actionState]);
  const [actionType, setActionType] = useState<SystemSettingActionType>(
    props.type,
  );
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState<CollectDestPreviewState>('loading');
  const [data, setData] = useState<CollectSetting>({
      systemId: '',
      tokenSetting: {
        ETHEREUM: {
          USDT: {
            active: true,
            collectDest: '',
            minimumAmount: 0,
          },
          ETH: {
            active: true,
            collectDest: '',
            minimumAmount: 0,
          },
        },
        TRON: {
          USDT: {
            active: true,
            collectDest: '',
            minimumAmount: 0,
          },
        },
        SOLANA: {
          USDT: {
            active: true,
            collectDest: '',
            minimumAmount: 0,
          },
        },
        XRP: {
          XRP: {
            active: true,
            collectDest: '',
            minimumAmount: 0,
          },
        }
      },
      networkFeeSetting: {
        ETHEREUM: {
          USDT: {
            transferMode: '',
          },
          ETH: {
            transferMode: '',
          },
        },
        TRON: {
          USDT: {
            transferMode: '',
          },
        },
        SOLANA: {
          USDT: {
            transferMode: '',
          },
        },
        XRP: {
          XRP: {
            transferMode: '',
          },
        }
      },
    },
  );

  const opLogger = useOperatorLogger();

  const successHandle = () => {
    if (formRef.current) formRef.current.resetFields();
    actionState.next(ActionType.Closed);
  };

  const formSave = () => {
    if (formRef.current) {
      switch (actionType) {
        case SystemSettingActionType.Edit:
          if (props.systemId)
            formRef.current.validateFields().then((value) => {

              for (const channel in data.tokenSetting) {
                const tokenList = data.tokenSetting[channel];
                for (const token in tokenList) {
                  data.tokenSetting[channel][token].minimumAmount = value[`${channel}_${token}_minimumAmount`] ??
                    data.tokenSetting[channel][token].minimumAmount;
                  data.tokenSetting[channel][token].collectDestType =
                    value[`${channel}_${token}_collectDestType`] ??
                    data.tokenSetting[channel][token].collectDestType;
                  // networkFeeSetting 不保證跟 tokenSetting 對齊(有些商戶少某些
                  // channel/token 組合,例如缺 XRP.XRP 或 TRON.TRX),沒有對應
                  // 條目就跳過,不要整支往下寫造成 TypeError。
                  if (!data.networkFeeSetting[channel]?.[token]) {
                    continue;
                  }
                  data.networkFeeSetting[channel][token].transferMode = value[`${channel}_${token}_transferMode`] ??
                    data.networkFeeSetting[channel][token].transferMode;
                  data.networkFeeSetting[channel][token].staticFee = value[`${channel}_${token}_staticFee`] ??
                    data.networkFeeSetting[channel][token].staticFee;
                }
              }

              const d = JSON.parse(JSON.stringify(data));
              const v = JSON.parse(JSON.stringify(value));
              const req = { ...d, ...v };

              CollectSettingProvider.updateSetting(
                { ...d, ...v },
                // metaData.curSystemId!,
              ).then(
                (res) => {
                  Modal.success({
                    content: '修改成功',
                    okText: '確認',
                    onOk: () => successHandle(),
                  });
                  opLogger.log({
                    action: '修改',
                    payload: {
                      req: req,
                      res: res,
                    },
                    systemId: props.systemId,
                  });
                },
                (err) => {
                  fromEditErrorModel(err as any, { type: '更新失敗' });
                  opLogger.log({
                    action: '修改',
                    payload: {
                      req: req,
                      res: err,
                    },
                    systemId: props.systemId,
                  });
                },
              );

            }).catch((err) => {
              // errorFields 是 antd validateFields 驗證失敗的形狀,顯示成一般
              // 表單提示;其他例外(例如上面迴圈的 TypeError)才當系統錯誤跳
              // Modal.error,絕不能整個吞掉讓送出鍵看起來毫無反應。
              if (err && Array.isArray(err.errorFields)) {
                Modal.error({
                  title: '表單驗證失敗',
                  content: (
                    <div>
                      <ul>
                        {err.errorFields.map((f: { name: (string | number)[]; errors: string[] }, i: number) => (
                          <li key={i}>{f.name.join('.')}: {f.errors.join('; ')}</li>
                        ))}
                      </ul>
                    </div>
                  ),
                  okText: '確認',
                });
                return;
              }
              console.error(err);
              Modal.error({
                title: '更新失敗',
                content: <div>{err?.message ?? String(err)}</div>,
                okText: '確認',
              });
            });
          break;
      }
    }
  };
  useEffect(() => {
    setActionType(props.type);
  }, [props.type]);

  useEffect(() => {
    // 每次 effect 重跑(切換商戶、開/關抽屜)一律先重置成 loading。
    // 這是修 I5 的關鍵一步:沒有這行,開完商戶 A 再開商戶 B,B 的資料還沒回來前
    // 畫面會沿用 A 殘留的 preview(下拉可選性、地址欄都是 A 的),而不是「載入中」。
    setPreview('loading');

    if (props.systemId && props.visible) {
      setLoading(true);
      if (formRef.current) {
        formRef.current.setFieldsValue({
          TRON_USDT_collectDest: '載入中…',
        });
      }
      CollectSettingProvider.getSetting(props.systemId)
        .then((data) => {
          if (formRef.current != null) {

            const componentNum: NumberComponentType = {};
            const componentStr: StringComponentType = {};

            for (const channel in data.tokenSetting) {
              const tokenList = data.tokenSetting[channel];
              for (const token in tokenList) {
                componentNum[`${channel}_${token}_minimumAmount`] =  data.tokenSetting[channel][token].minimumAmount;
                componentStr[`${channel}_${token}_collectDest`] =  data.tokenSetting[channel][token].collectDest;
              }
            }
            formRef.current.setFieldsValue(componentNum)
            formRef.current.setFieldsValue(componentStr)
          }
          setData(data);

          CollectSettingProvider.getDestPreview(props.systemId).then(
            (p) => {
              setPreview(p);
              if (formRef.current) {
                formRef.current.setFieldsValue({
                  TRON_USDT_collectDestType: p.destType,
                  TRON_USDT_collectDest: p.address ?? '(解析不到,請檢查商戶錢包)',
                });
              }
            },
            () => {
              setPreview('failed');
              if (formRef.current) {
                formRef.current.setFieldsValue({
                  TRON_USDT_collectDest: '(載入失敗,請重新整理再確認)',
                });
              }
            },
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.systemId, actionType, props.visible]);

  return (
    <>
      <CoreDrawer
        title={'編輯歸集設定'}
        width={640}
        visible={props.visible}
        onClose={() => {
          actionState.next(ActionType.Closed);
        }}
        destroyOnClose={true}
        footerbuttons={[
          <Button key={1} onClick={formSave}>
            送出
          </Button>,
        ]}
      >
        <Spin spinning={loading}>
          <Form
            ref={formRef}
            layout='vertical'
            name='systemSettingForm'
            initialValues={data}
          >
            <Tabs type='card'>
              {
                _.map(data.tokenSetting, (channelObj, channel) => {
                  let isTokenActive = false;
                  _.map(channelObj, (tokenObj, token) => {
                    if (tokenObj.active) {
                      isTokenActive = true;
                    }
                  });
                  if (isTokenActive) {
                    keyNumber++;
                    return (
                      <Tabs.TabPane key={keyNumber} tab={channel}>
                        <CollectTokenSettingFrom
                          tokenSetting={data.tokenSetting}
                          channel={channel}
                          data={channelObj}
                          networkFeeSetting={data.networkFeeSetting}
                          preview={preview}
                        />
                      </Tabs.TabPane>
                    );
                  }
                })
              }
            </Tabs>
          </Form>
        </Spin>
      </CoreDrawer>
    </>
  );
};

export default CollectSettingForm;
